<script>
import { XIcon } from 'vue-feather-icons'
import Quagga from 'quagga'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  components: { XIcon },
  extends: BaseModal,
  data: function () {
    return {
      deviceId: ''
    }
  },
  computed: {
    headerStyle() {
      return this.$isRemoteClient && this.$route.path != '/qr' ? { top: '7rem' } : {}
    }
  },
  mounted() {
    eventBus.$emit('refresh-token-via-websockets')

    Quagga.onDetected((data) => {
      this.onDecode(data.codeResult.code)
    })
    Quagga.init(
      {
        inputStream: {
          type: 'LiveStream',
          constraints: {
            width: 2576,
            height: 1932,
            facingMode: 'user'
          },
          target: document.querySelector('#video')
        },
        locator: {
          patchSize: 'medium'
          // halfSample: true
        },
        numOfWorkers: 4,
        decoder: {
          readers: [
            'code_128_reader'
            // "ean_reader",
            // "ean_8_reader",
            // "code_39_reader",
            // "code_39_vin_reader",
            // "codabar_reader",
            // "upc_reader",
            // "upc_e_reader"
            // "i2of5_reader",
            // "2of5_reader",
            // "code_93_reader"
          ]
        }
      },
      function (err) {
        if (err) {
          console.log(err)
          return
        }
        console.log('Initialization finished. Ready to start')
        Quagga.start()
      }
    )
  },
  beforeDestroy() {
    Quagga.stop()
  },
  methods: {
    onDecode(event) {
      this.close(event)
    }
  }
}
</script>

<template lang="pug">
span
  .modal-fixed-text-top(:style="headerStyle")
    h3 {{ $t('scanBarcode') }}
    .modal-fixed-controls(@click="close(false)")
      x-icon(size="1.5x")
  .modal-body.p-0.h-100.d-flex.align-items-center
    #video
  .modal-fixed-text-bottom
    h3 {{ $t('scanBarcode') }}
</template>

<style lang="scss" scoped>
@import '@/assets/styles/mixins.scss';
.modal-body {
  background: black;
}
</style>
